import React from "react";
import { Box } from "@mui/material";
import { alpha } from "@mui/material/styles";
import { gray } from "@/theme/colors";

/**
 * The panel style's two-part chrome, for pages that don't use
 * IndexLayoutShell (organizations, events, professionals).
 *
 * Articles and regulations get this from the shell; the other three own
 * their page wrappers, so selecting style 2 there previously changed only
 * the header and left the page on its neutral wash with no card — which
 * is why it didn't match.
 *
 * `panelPageSx` tints the outermost page wrapper; `IndexPanelSurface`
 * floats the white card that content sits on. Both are inert unless the
 * style is 2, so call-sites can apply them unconditionally.
 */

/** Page wash: accent-tinted under the panel style, neutral otherwise. */
import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
export function panelPageSx(style, accentPrimary) {
  return {
    backgroundColor: style === 2 ? alpha(accentPrimary, 0.1) : alpha(gray.light, 0.1)
  };
}
/** White content card — only under the panel style. */
export default function IndexPanelSurface({
  style,
  children
}) {
  if (style !== 2) return /*#__PURE__*/_jsx(_Fragment, {
    children: children
  });
  return /*#__PURE__*/_jsx(Box, {
    sx: {
      // No minHeight: this card only ever wraps the page header
      // (title + actions). Forcing 300px left a block of dead
      // whitespace under the buttons after the filter bar moved
      // out of the card.
      p: {
        xs: 2.5,
        md: 3,
        lg: 4
      },
      "@media (max-width:375px)": {
        p: 2
      },
      backgroundColor: "background.paper",
      borderRadius: 1,
      boxShadow: 1,
      my: 3
    },
    children: children
  });
}